import React from 'react';
import packageJson from '../../package.json';

const Footer = () => {
  return (
    <footer style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(0, 0, 0, 0.1)',
      padding: '8px 20px',
      textAlign: 'center',
      fontSize: '12px',
      color: 'var(--text-light)',
      zIndex: 1000
    }}>
      NotesNCodes v{packageJson.version}
    </footer>
  );
};

export default Footer;